import React, { forwardRef } from "react";
import { Icon } from "@iconify/react";
import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";

interface IconifyProps {
  icon: string;
  width?: number;
  sx?: SxProps<Theme>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const Iconify = forwardRef<HTMLElement, IconifyProps>(
  ({ icon, width = 20, sx, ...other }, ref) => (
    <Box
      ref={ref}
      component={Icon as React.ElementType}
      className="component-iconify"
      icon={icon}
      sx={{ width, height: width, ...sx }}
      {...other}
    />
  ),
);

Iconify.displayName = "Iconify";

export default Iconify;
